export const APP_ENV = process.env
